module.exports = __webpack_public_path__ + "static/media/icn_kids.89c6b731.svg";